<template>
    <div class="filter-min-max">
        <div class="filter-label" @click="showOptions = !showOptions">
            <div>{{ t('segments-filters-birthdays_of_month') }}</div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.field {
    display: flex;
    &.column {
        flex-direction: column;
        padding: 0 10px;
        label {
            margin-left: 0;
            padding-left: 0;
        }
    }
    label {
        width: auto;
        display: block;
        margin-right: 10px;
    }
}
</style>
<script>
export default {
    name: "birthdate",
    props: {
        currentValue: {
            type: Number,
            default: 1,
        },
        name: {
            type: String,
            default: "birthdate",
        },
    },
    data() {
        return {
            showOptions: false,
            value: 1,
        };
    },
    mounted() {
        if (this.currentValue) {
            this.value = this.currentValue;
        }
        if (this.value) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed() {
            this.$emit("changed", this.value);
        },
    },
    watch: {
        value() {
            this.changed();
        },
    },
};
</script>
